<!--<div>
  <mat-select placeholder="Select DataSource" style="width: 70%" [(ngModel)]="pieChartQuery2.dataset">
    <mat-option *ngFor="let datasetDefinition of datasetDefinitions | keyvalue" [value]="datasetDefinition.key">
      {{datasetDefinition.key}}
    </mat-option>
  </mat-select>

</div>-->
<!--<date-picker [(startDate)]="startDateFilter.value" [(endDate)]="endDateFilter.value"></date-picker>-->

<div class="sidenav-toggle" *ngIf="expandedElement == null">
  <button mat-button (click)="sidenav.toggle()"><mat-icon *ngIf="!sidenav?.opened">menu</mat-icon><mat-icon *ngIf="sidenav?.opened">menu_open</mat-icon></button>
</div>

<!--<button mat-button (click)="cradleToGraveNav()" style="margin-top:0">Cradle To Grave</button>-->

<mat-sidenav-container class="example-container">

  <mat-sidenav #sidenav mode="side" [(opened)]="menuOpened" position="end" [style.display]="expandedElement == null ? 'block': 'none'">
    <h3 class="side-menu-header">Menu</h3>


    <form class="example-form">
      <div>
        <p-calendar name="globalFilters.dateRange" [ngModel]="[startDate | async,endDate | async]" (ngModelChange)="startDate.next($event[0]);endDate.next($event[1])" selectionMode="range" [readonlyInput]="true" inputId="range" dateFormat="dd/mm/yy" [showIcon]="true" showButtonBar="true" [minDate]="minStartDate | async"></p-calendar>
      </div>

      <div>
        <companies-autocomplete (onSelectCompany)="company.next($event)"></companies-autocomplete>
      </div>


      <h3 class="side-menu-header" style="font-size:1em">Working Hours</h3>
      <div style="position:relative" class="clearfix">
        <input name="sartTimeTimePicker" matInput [ngxTimepicker]="startTimeTimePicker" [format]="24" placeholder="--:--" [ngModel]="workingHoursStartTime | async" (ngModelChange)="workingHoursStartTime.next($event)" class="eveInput" readonly />
        <ngx-material-timepicker #startTimeTimePicker></ngx-material-timepicker>
        <span *ngIf="(workingHoursStartTime | async) != ''" class="workingHoursTimeClear material-icons" (click)="workingHoursStartTime.next('')">close</span>
      </div>

      <div style="position:relative" class="clearfix">
        <input name="endTimeTimePicker" matInput [ngxTimepicker]="endTimeTimePicker" [format]="24" placeholder="--:--" [ngModel]="workingHoursEndTime | async" (ngModelChange)="workingHoursEndTime.next($event)" class="eveInput" readonly />
        <ngx-material-timepicker #endTimeTimePicker></ngx-material-timepicker>
        <span *ngIf="(workingHoursEndTime | async) != ''" class="workingHoursTimeClear material-icons" (click)="workingHoursEndTime.next('');">close</span>
      </div>

      <mat-form-field appearance="fill" style="display:none">
        <mat-label>Scale</mat-label>
        <mat-select [(value)]="scale">
          <mat-option value="1">Large</mat-option>
          <mat-option value="1.5">Medium</mat-option>
          <mat-option value="2">Small</mat-option>
        </mat-select>


      </mat-form-field>
    </form>
  </mat-sidenav>

  <mat-sidenav-content>
    <div style="padding: 1%">
      <mat-grid-list cols="4" [rowHeight]="(document.documentElement.clientHeight / scale) - 40" [gutterSize]="'20px'">



        <mat-grid-tile [colspan]="2">

          <div #totalMissedCallsExpandable class="expandable" [class.fullscreen]="expandedElement==totalMissedCallsExpandable">            
            <div class="tile-container">
              <total-missed-calls #totalMissedCalls
                                  [loading]="loading"
                                  [noResults]="noResults"
                                  [wheres]="wheres| async"
                                  (select)="onEveCdrGraphSelect($event)">
              </total-missed-calls>
              <ng-container *ngTemplateOutlet="totalMissedCalls.template"></ng-container>
            </div>

            <mat-grid-tile-header>
              Total Missed Calls
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? totalMissedCallsExpandable: null)" title="{{expandedElement == totalMissedCallsExpandable ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == totalMissedCallsExpandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div #missedCallsByUserRatingExpandable class="expandable" [class.fullscreen]="expandedElement==missedCallsByUserRatingExpandable">
            <div class="tile-container">

              <ng-container *ngIf="missedCallsByUserRating | async as _missedCallsByUserRating; else loading">
                <leaderboard *ngIf="_missedCallsByUserRating.length > 0 else noResults"
                             [results]="_missedCallsByUserRating"
                             (select)="onTelepoCdrGraphSelect($event)">
                </leaderboard>
              </ng-container>

            </div>
            <mat-grid-tile-header>
              Missed Calls User Rating
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? missedCallsByUserRatingExpandable: null)" title="{{expandedElement == missedCallsByUserRatingExpandable ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == missedCallsByUserRatingExpandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>

        </mat-grid-tile>



        <mat-grid-tile>
          <div #answerCallsPerformanceExpandable class="expandable" [class.fullscreen]="expandedElement==answerCallsPerformanceExpandable">
            <div class="tile-container">
              <ng-container *ngIf="answerCallsPercentageResults | async as _answerCallsPercentageResults; else loading">
                <fuel-gauge-new *ngIf="_answerCallsPercentageResults.length > 0 else noResults"
                                [results]="_answerCallsPercentageResults"
                                min="0"
                                max="100"
                                [legend]="true"
                                (select)="onAnsweredPerformanceSelect($event)">
                </fuel-gauge-new>
              </ng-container>
            </div>

            <mat-grid-tile-header>
              Answered Performance
              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? answerCallsPerformanceExpandable: null)" title="{{expandedElement == answerCallsPerformanceExpandable ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == answerCallsPerformanceExpandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>

        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div #missedCallsByGroupExpandable class="expandable" [class.fullscreen]="expandedElement==missedCallsByGroupExpandable">
            <div class="tile-container">
              <missed-calls-by-group #missedCallsByGroup
                                     [loading]="loading"
                                     [noResults]="noResults"
                                     [wheres]="wheres| async"
                                     [company]="company | async"
                                     (select)="onTelepoCdrGraphSelect($event)"></missed-calls-by-group>
              <ng-container *ngTemplateOutlet="missedCallsByGroup.template"></ng-container>
            </div>
            <mat-grid-tile-header>
              Missed Calls By Groups

              <span class="example-spacer"></span>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="missedCallsByGroup.openGroupSelectionDialog()" title="group selection">
                <mat-icon>search</mat-icon>
              </button>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? missedCallsByGroupExpandable: null)" title="{{expandedElement == missedCallsByGroupExpandable ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == missedCallsByGroupExpandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>

        </mat-grid-tile>


        <mat-grid-tile [colspan]="2">
          <div #missedCallsByUserExpandable class="expandable" [class.fullscreen]="expandedElement==missedCallsByUserExpandable">
            <div class="tile-container">
              <missed-calls-by-user
                                    #missedCallsByUser
                                    [loading]="loading"
                                    [noResults]="noResults"
                                    [wheres]="wheres| async"
                                    [company]="company | async"
                                    (select)="onTelepoCdrGraphSelect($event)">
              </missed-calls-by-user>
              <ng-container *ngTemplateOutlet="missedCallsByUser.template"></ng-container>
            </div>
            <mat-grid-tile-header>
              Missed Calls By User
              <span class="example-spacer"></span>

              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="missedCallsByUser.openUserSelectionDialog()" title="user selection">
                <mat-icon>person_search</mat-icon>
              </button>
              <button mat-icon-button style="color:#be0078; background-color: transparent;" (click)="expandedElement=(expandedElement == null ? missedCallsByUserExpandable: null)" title="{{expandedElement == missedCallsByUserExpandable ? 'minimise' : 'expand'}}">
                <mat-icon>{{expandedElement == missedCallsByUserExpandable ? "minimize" : "expand"}}</mat-icon>
              </button>
            </mat-grid-tile-header>
          </div>

        </mat-grid-tile>

      </mat-grid-list>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>



<ng-template #loading>

  <!--<div style="margin-top: 135px; ">
    <img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" style="display: block; margin: auto;" class="loading" />
    <div style="color: #646965; text-align: center">loading...</div>
  </div>-->

  <div style="color:gray; display: block; margin: auto;">
    <span *ngIf="!results" class="fa fa-spinner fa-pulse fa-5x" style=" color:gray;"></span>

  </div>


</ng-template>


<ng-template #noResults>

  <div style="margin-top: 135px; ">
    <img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" style="opacity: 0.2; color: gray; display: block; margin: auto;" />
    <div style="color: #646965; text-align: center">no results found</div>
  </div>

</ng-template>





<ng-template #EveCdrsDialogTemplate let-query="query">
  <evecdr-datatable [query]="query">
  </evecdr-datatable>
</ng-template>


<ng-template #TelepoCdrsDialogTemplate let-query="query">
  <telepocdr-datatable [query]="query">
  </telepocdr-datatable>
</ng-template>


